import axios from 'axios'
import APIConfig from '@/data/remote/APIConfig.js'

export default class CompensatoryTimeService {
    constructor() {
        this.apis = {
            getAll: () => axios.get(APIConfig.APIURL + '/compensatoryTime'),
            add: (payload) => axios.post(APIConfig.APIURL + '/compensatoryTime', payload),
            edit: (id, payload) => axios.put(APIConfig.APIURL + `/compensatoryTime/${id}`, payload),
            inActivate: (id) => axios.post(APIConfig.APIURL + `/compensatoryTime/${id}/inactivate`),
            // delete: (id) => axios.delete(APIConfig.APIURL + `/compensatoryTime/${id}`),
            reject: (id, payload) => axios.post(APIConfig.APIURL + `/compensatoryTime/${id}/reject`, payload),
            sign: (id) => axios.post(APIConfig.APIURL + `/compensatoryTime/${id}/sign`),
        }
    }

    prepareData(vm) {
        return new Promise((resolve, reject) => {
            if (vm.$store.state.compensatoryTime.isFetched) {
                resolve(vm.$store.state.compensatoryTime.list)
                return
            }
            if (vm.$store.state.compensatoryTime.isFetching) {
                var timer = setInterval(() => {
                    if (vm.$store.state.compensatoryTime.isFetching) return
                    clearInterval(timer)
                    if (vm.$store.state.compensatoryTime.isFetched) {
                        resolve(vm.$store.state.compensatoryTime.list)
                    } else {
                        reject('無法取得資料，請嘗試重新整理')
                    }
                }, 500)
                return
            }
            return this.getAll(vm)
                .then(res => {
                    vm.$store.state.compensatoryTime.isFetched = true
                    vm.$store.state.compensatoryTime.isReloaded = false
                    vm.$store.state.compensatoryTime.list = res.data.result || []
                    return res
                })
                .then(res => {
                    vm.$store.state.compensatoryTime.isFetching = false
                    resolve()
                    return res
                })
                .catch(err => {
                    vm.$store.state.compensatoryTime.isFetching = false
                    reject(err)
                })
        })
    }

    getAll(vm) {
        return new Promise((resolve, reject) => {
            this.apis.getAll()
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    add(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.add(payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    edit(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.edit(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    inActivate(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.inActivate(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    delete(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.delete(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    reject(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.reject(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    sign(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.sign(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }
}
